import styled from '@emotion/styled';
import { AddOns } from '@racemap/sdk/schema/billing/AddOns';
import { Col, Row } from 'antd';
import type { FC } from 'react';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useEventFieldGenerator } from 'src/lib/customHooks/useEventFieldGenerator';
import { InfoPanel, TabPanel } from '../EventEditor/TabComponents';
import { PredictionChecklist } from './PredictionChecklist';
import PredictionWalkTroughGoogleCalenderRequest from './PredictionWalkTroughGoogleCalenderRequest';

export const StatusSubTab: FC = () => {
  const event = useCurrentEvent();
  const fieldGenerator = useEventFieldGenerator(event);

  if (fieldGenerator == null || event == null) return <></>;

  const { value, onChange } = fieldGenerator('modules.predictive.enabled');

  return (
    <Container>
      <Row gutter={24}>
        <Col span={19}>
          <InfoPanel
            state={value}
            addOn={AddOns.PREDICTIVE}
            onActivation={() => onChange(true)}
            onDeactivation={() => onChange(false)}
          />
        </Col>
        <Col span={5}>
          <TabPanel title="Help">
            <div style={{ fontSize: 'medium', marginTop: '12px' }}>
              <p>Interested in prediction?</p>
              <p>Want to get a walkthrough?</p>
              <div style={{ marginTop: '30px', fontSize: '0.875em', fontWeight: 400 }}>
                <PredictionWalkTroughGoogleCalenderRequest />
              </div>
            </div>
          </TabPanel>
        </Col>
      </Row>

      <Row>
        <Col>
          <PredictionChecklist />
        </Col>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  padding: 30px 25px;

  .bordered-box {
    margin-bottom: 20px;
    padding: 15px;
  }
`;
